{
  "id": "001-010",
  "title": "Following directions",
  "layout": {
    "offset": "odd-row",
    "tiles": {
      "0": {
        "0": {
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "direction": 0,
              "id": "916477d6"
            }
          ],
          "id": "75df857a"
        },
        "1": {
          "id": "43142953",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 5
                }
              ],
              "id": "1ce44eba"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "9ba8bd9e"
            }
          ]
        },
        "-1": {
          "id": "da8da7c6",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 2,
                  "toggled": true,
                  "steps": {
                    "3": {
                      "portal": {
                        "entryportalid": "916477d6",
                        "exitportalid": "388f88d4"
                      }
                    }
                  }
                }
              ],
              "id": "5363af1f"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "9556062f"
            }
          ]
        }
      },
      "1": {
        "0": {
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "direction": 5,
              "id": "c2c04bc7"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "0c3fe41a"
            }
          ],
          "id": "c92e21e3"
        },
        "-1": {
          "id": "62c320fa",
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "direction": 5,
              "id": "f75c4e92"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "97b3cf21"
            }
          ]
        }
      },
      "-1": {
        "0": {
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "direction": 5,
              "id": "88b59156"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "5871082a"
            }
          ],
          "id": "210e5463"
        },
        "-1": {
          "id": "720d0180",
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "id": "388f88d4"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "5b0d7431"
            }
          ]
        }
      }
    },
    "modifiers": [
      {
        "type": "rotate",
        "id": "b30a8952"
      }
    ]
  },
  "requirements": [
    {
      "type": "connections",
      "amount": 1
    }
  ],
  "version": 0
}
